import { Component, OnInit, Input, Output, EventEmitter, ElementRef, ViewChild } from '@angular/core';
import { NotificationService } from 'src/app/services/notification.service';

@Component({
  selector: 'app-isomasters-input',
  templateUrl: './isomasters-input.component.html',
  styleUrls: ['./isomasters-input.component.scss'],
})
export class IsomastersInputComponent implements OnInit {
  @Input() type = 'text';
  @Input() autocomplete = false;
  private _val: number;

  @Input() set value(value: number) {
    this._val = value;

    setTimeout(() => {
      if (this.input) {
        this.processNewInput(this.input.nativeElement);
      }
    }, 10);
  }

  get value() {
    return this._val;
  }

  @Output() valueChange = new EventEmitter<any>();
  @Input() placeholder = '';
  @Input() max: number;
  @Input() min: number;
  @Input() step: number;
  @ViewChild('input') input: ElementRef;
  @Input() selectId = 'default';

  error = false;

  get currentTarget(): HTMLInputElement {
    if (this.input) {
      this.input.nativeElement.id = this.selectId;
      return this.input.nativeElement;
    }

    return null;
  }

  constructor(
    private notificationService: NotificationService,
    private host: ElementRef
  ) {}

  ngOnInit() {
    document.addEventListener('click', (event: Event) => {
      if ((event.target as Element).closest('#' + this.selectId) === null) {
        this.lostFocus();
      }
    });

    (this.host.nativeElement as HTMLElement).id = this.selectId;
  }

  processNewInput(target: HTMLInputElement): boolean {
    if (!target.validity.valid || !target.value) {
      this.notificationService.showBalloonNotification(
        this.getErrorMessage(+this.currentTarget.value),
        this.currentTarget,
        0,
        true
      );
      this.error = true;
      return false;
    } else if (+target.value === this.max) {
      this.notificationService.showBalloonNotification(
        'INPUT.SUGGESTION.CONTACT',
        this.currentTarget,
        NotificationService.DEFAULT_TIMEOUT,
        false
      );
    } else {
      this.notificationService.hideBalloonNotification(this.selectId);
      this.error = null;
    }

    return true;
  }

  emit(target: HTMLInputElement) {
    if (!this.processNewInput(target)) {
      return;
    }

    this.error = false;
    this.valueChange.emit(target.value);
  }

  getErrorMessage(value: number): string {
    if (value < this.max && value > this.min) {
      return 'INPUT.ERROR.INVALIDSTEPSIZE';
    } else if (value >= this.max) {
      return 'INPUT.SUGGESTION.CONTACT';
    } else if (value <= this.min) {
      return 'INPUT.ERROR.TOOSMALL';
    } else {
      return '';
    }
  }

  gotFocus() {
    if (this.error) {
      this.notificationService.showBalloonNotification(
        this.getErrorMessage(+this.currentTarget.value),
        this.currentTarget,
        0,
        true
      );
    } else if (+this.currentTarget.value === this.max) {
      this.notificationService.showBalloonNotification(
        'INPUT.SUGGESTION.CONTACT',
        this.currentTarget,
        NotificationService.DEFAULT_TIMEOUT,
        false
      );
    }
  }

  lostFocus() {
    this.notificationService.hideBalloonNotification(this.selectId);
  }

  emitCheckbox(target: HTMLInputElement) {
    this.valueChange.emit(target.checked);
  }
}
